// module
import { useMemo, useEffect, useState, useRef } from 'react';
import { Box, Container, List, ListItem, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
// constants
import { declOfMonth } from 'common/helpers';
// style
import classes from './Information.module.scss';


const PERCENT = 10;
const TIME_INTERVAL = 100;

const Information = (props) => {
  const { t } = useTranslation();
  const { data } = props;
  const {
    duration,
    price,
    lessons_amount,
    teachers_count,
    image,
    image_alt
  } = data;

  const teachersInt = +(teachers_count?.split(' ')?.[ 0 ]);
  const onScroll = useRef();

  const [ counts, setCounts ] = useState({
    duration: 0,
    price: 0,
    lessons_amount: 0,
    teachers_count: 0,
  });
  const monthDurationText = `${declOfMonth(counts?.duration)} курса`;
  const resultMonthDurationText = (e) => e === 'Месяцев курса' ? monthDurationText : e;
  const [ hover, setHover ] = useState(true);

  const increment = (count = counts) => {
    if (!hover) {
      setCounts({
        duration: 0,
        price: 0,
        lessons_amount: 0,
        teachers_count: 0,
      });
    } else {
      if (
        count?.duration < duration - (duration / PERCENT)
        || count?.price < price - (price / PERCENT) ||
        count?.lessons_amount < lessons_amount - (price / PERCENT) ||
        count?.teachers_count < teachersInt - (price / PERCENT)
      ) {
        count = {
          duration: count?.duration + (duration / PERCENT),
          price: count?.price + (price / PERCENT),
          lessons_amount: count?.lessons_amount + (lessons_amount / PERCENT),
          teachers_count: count?.teachers_count + (teachersInt / PERCENT),
        };
        setCounts(count);
        setTimeout(() => increment(count), TIME_INTERVAL);
      } else {
        setCounts({
          duration,
          price,
          lessons_amount,
          teachers_count: teachersInt,
        });
      }
    }
  };

  const info = useMemo(() => {
    const obj = {
      [ t('CourseMonths') || 'Месяцев курса' ]: counts?.duration,
      [ t('SomPerMonth') || 'Сомов в месяц' ]: counts?.price,
      [ t('Classes') || 'Занятий' ]: counts?.lessons_amount,
      [ teachers_count?.split(' ')?.[ 1 ] || t('TeachersSecond') ]: counts?.teachers_count,
    };
    return (
      <List className={classes.list}>
        {
          Object.keys(obj).map((e, i) => (
            <ListItem className={classes.item} key={i}>
              <Typography className={classes.count} variant='h3'>{Math.floor(obj[ e ])}</Typography>
              <Typography className={classes.label}>{resultMonthDurationText(e)}</Typography>
            </ListItem>
          ))
        }
      </List>
    );
  }, [ counts, teachersInt ]);

  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (!onScroll) return;

      const position = onScroll.current?.getBoundingClientRect() || { top: 0 };
      setHover(position.top <= window.innerHeight);
    });
    return () => window.removeEventListener('scroll', () => null);
  }, [ counts ]);

  useEffect(() => {
    increment();
    return () => null;
  }, [ hover ]);
  return (
    <Container>
      <Box className={classes.info} ref={onScroll}>
        {info}
        <Box
          component='img'
          className={classes.img}
          src={image}
          alt={image_alt}
          data-aos='fade-up'
          data-aos-duration={800}/>
      </Box>
    </Container>
  );
};

export default Information;
